import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white text-center py-4">
      <div className="container mx-auto">
        <p className="mb-0">
          Developed by <a 
            href="https://avahub.co.uk" 
            className="text-white font-bold hover:text-blue-300" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            AvaHub
          </a>. © {new Date().getFullYear()} All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;